import {Alert, Button, Container, Form, Row, Spinner} from "react-bootstrap";
import PageHeader from "../../components/pageheader/pageheader";

import './style.css';
import {getLogin} from "../../api/getbyparty";
import { useNavigate } from "react-router-dom";
import {useState} from "react";
import {FC} from "react";

interface LoginProps {}

const Login: FC<LoginProps> = ({ }) => {  {

    const navigate = useNavigate();

    const [errorDisabled, setErrorDisabled] = useState(false);
    const [spinnerDisplay, setSpinnerDisplay] = useState(false);

    const submitForm = (event) => {
        event.preventDefault();
        let formData = new FormData(event.target),
            formDataObj = Object.fromEntries(formData.entries());
        setSpinnerDisplay('block');
        setErrorDisabled(false);
        getLogin(formDataObj).then(r => {
            if (r) {
                navigate("/portal")
            } else {
                setSpinnerDisplay(false);
                setErrorDisabled(true);
            }
        })
    }

    return (
        <Container fluid="md">
            <Row>
                <div className="loginHeader"><PageHeader headerValue={'Secret Santa'} textSize={36}/></div>
            </Row>
            <Row>
                <div className="loginSubHeader"><PageHeader headerValue={'Login'} textSize={18}/></div>
            </Row>
            <Row>
                {spinnerDisplay &&
                    <Spinner className="centerRow" animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                }
            </Row>
            <Alert key='login-error' variant='danger' className='login-error' show={errorDisabled}>
                Error logging in!
            </Alert>
            <Row>
                <Form className="loginForm" onSubmit={submitForm}>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>email</Form.Label>
                        <Form.Control disabled={spinnerDisplay} type="text" name="email" placeholder="Enter email" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>password</Form.Label>
                        <Form.Control disabled={spinnerDisplay} type="password" name="password" placeholder="Enter your password" />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formLogin">
                        <Button disabled={spinnerDisplay} type="submit">Login</Button>
                    </Form.Group>
                </Form>
            </Row>
        </Container>)

}}

export default Login;